import React, { useEffect, useState } from 'react';
import { Button, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import axios from 'axios';
import { host, url } from '../../../config/common';
import Loader from '../../utils/loader';
import CustomPagination from './pagination/customPagination';
import SocialContentCard from '../../utils/socialContentCard';
import { useNavigate } from 'react-router-dom';

const SocialContent = () => {
    const [searchInput, setSearchInput] = useState("");
    const [socialContentData, setSocialContentData] = useState({
        list: [],
        loading: false,
        currentPage: "1",
        totalPages: 1,
        totalRecords: 1,
    });
    const [socialParams, setSocialParams] = useState({
        page: 1,
        limit: 21,
    });
    const [showloader, setShowloader] = useState(false);
    let navigate = useNavigate();

    const fetchSocialMediaContent = async () => {
        try {
            setShowloader(true)
            let fetchedEventData = await axios({
                method: 'get',
                headers: { 'x-access-token': JSON.parse(localStorage.getItem('user'))?.token ? JSON.parse(localStorage.getItem('user')).token : "" },
                url: `${host}${url.getShareAnUpdate}?search=${searchInput}&page=${socialParams.page}&limit=${socialParams.limit}&eventName=social_media_content`
            });
            if (fetchedEventData?.status == 401) {
                localStorage.removeItem("user")
                return navigate("/")
            }
            if (fetchedEventData) {
                setShowloader(false);
                setSocialContentData((v) => ({
                    ...v,
                    list: fetchedEventData?.data?.data?.records,
                    loading: false,
                    currentPage: fetchedEventData?.data?.data?.currentPage,
                    totalPages: fetchedEventData?.data?.data?.totalPages,
                    totalRecords: fetchedEventData?.data?.data?.totalRecords,
                }));
            }
        } catch (error) {
            console.log({ error });
            if (error?.response?.status == 401) {
                localStorage.removeItem("user")
                return navigate("/")
            }
        }
    }

    const searchContent = async (e) => {
        try {
            setSocialParams((v) => ({ ...v, page: 1 }));
            fetchSocialMediaContent();
        } catch (error) {
            console.log({ error });
        }
    }

    const handlePageChange = (e, page) => {
        setSocialParams((v) => ({ ...v, page: page }));
    };

    const paginationProps = {
        currentPage: socialContentData?.currentPage,
        totalPages: socialContentData?.totalPages,
        totalRecords: socialContentData?.totalRecords,
        handlePageChange,
    };

    useEffect(() => {
        fetchSocialMediaContent();
    }, [socialParams]);

    return (
        <div style={{ padding: "0px 20px" }}>
            <Row>
                <Col>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h3>Social Media Content Requests</h3>
                    </div>
                </Col>
            </Row>
            <Row>
                <div>
                    <Row>
                        <Col xs="7">
                            <Form onSubmit={(e) => { e.preventDefault(); searchContent() }}>
                                <InputGroup style={{ width: "500px", float: "left", marginBottom: "1%" }}>
                                    <FormControl
                                        placeholder="Search by title"
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        value={searchInput}
                                    />
                                    <Button variant="outline-primary" type='submit'>
                                        Search
                                    </Button>
                                </InputGroup>
                            </Form>
                        </Col>
                    </Row>
                    <Loader show={showloader} />
                    <Row style={{ height: "82vh", overflow: "scroll " }}>
                        <Col>
                            {socialContentData?.list?.length > 0
                                ?
                                <>
                                    <Row style={{ marginTop: "20px" }}>
                                        {
                                            socialContentData?.list?.map((item) =>
                                                <Col sm="4" key={item._id}>
                                                    <SocialContentCard socialContentData={item} refreshData={() => fetchSocialMediaContent()} />
                                                </Col>
                                            )
                                        }
                                    </Row>
                                    <CustomPagination props={{ paginationProps }} />
                                </>
                                :
                                <Row style={{ marginTop: "20px" }}>No Records Found</Row>
                            }

                        </Col>
                    </Row>
                </div>
            </Row>
        </div>
    );
}

export default SocialContent;
